import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AIState } from '@handover/shared-types';

const initialState: AIState = {
  isChatGPTAssistantOpen: false,
  isChatGPTAddHandOverOpen: false,
  isChatGPTHandoverSummarizerOpen: false,
  assistantMessages: [],
  parserMessages: '',
  parserLoading: false,
  parserError: null,
  loading: false,
  error: null,
};

const aiSlice = createSlice({
  name: 'ai',
  initialState,
  reducers: {
    toggleChatGPTAssistant: state => {
      state.isChatGPTAssistantOpen = !state.isChatGPTAssistantOpen;
    },
    openChatGPTAssistant: state => {
      state.isChatGPTAssistantOpen = true;
    },
    closeChatGPTAssistant: state => {
      state.isChatGPTAssistantOpen = false;
    },
    toggleChatGPTAddHandOver: state => {
      state.isChatGPTAddHandOverOpen = !state.isChatGPTAddHandOverOpen;
    },
    openChatGPTAddHandOver: state => {
      state.isChatGPTAddHandOverOpen = true;
    },
    closeChatGPTAddHandOver: state => {
      state.isChatGPTAddHandOverOpen = false;
    },
    toggleChatGPTHandoverSummarizer: state => {
      state.isChatGPTHandoverSummarizerOpen = !state.isChatGPTHandoverSummarizerOpen;
    },
    openChatGPTHandoverSummarizer: state => {
      state.isChatGPTHandoverSummarizerOpen = true;
    },
    closeChatGPTHandoverSummarizer: state => {
      state.isChatGPTHandoverSummarizerOpen = false;
    },
    addAssistantMessage: (state, action: PayloadAction<string>) => {
      state.assistantMessages = [...state.assistantMessages, action.payload];
    },
    addParserMessage(state, action: PayloadAction<string>) {
      state.parserMessages = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setParserLoading: (state, action: PayloadAction<boolean>) => {
      state.parserLoading = action.payload;
    },
    setParserError: (state, action: PayloadAction<string | null>) => {
      state.parserError = action.payload;
    },
  },
});

export const {
  toggleChatGPTAssistant,
  openChatGPTAssistant,
  closeChatGPTAssistant,
  toggleChatGPTAddHandOver,
  openChatGPTAddHandOver,
  closeChatGPTAddHandOver,
  toggleChatGPTHandoverSummarizer,
  openChatGPTHandoverSummarizer,
  closeChatGPTHandoverSummarizer,
  addAssistantMessage,
  addParserMessage,
  setLoading,
  setError,
  setParserLoading,
  setParserError,
} = aiSlice.actions;

export default aiSlice.reducer;
